<template>
  <div>
    <div class="home_page">
      <Breadcrumb :pageTitle="pageTitle" />
    </div>
    <div class="all lianchulianbei home_page">
      <div
        style="width:100%;height:50px;width:100%;padding-top:5px;padding-bottom:5px;"
      >
        <div
          :class="{ zhuangtaiclick: number === 'all' }"
          class="zhuangtai"
          @click="changeStatus('all')"
        >
          {{$t('stockNeed.tabs1')}}
        </div>
        <div
          class="zhuangtai"
          :class="{ zhuangtaiclick: number === '0' }"
          @click="changeStatus('0')"
        >
          {{$t('stockNeed.tabs2')}}({{ shoulinumber }})
        </div>
        <div
          class="zhuangtai"
          :class="{ zhuangtaiclick: number === '1' }"
          @click="changeStatus('1')"
        >
          {{$t('stockNeed.tabs3')}}({{ querenNumber }})
        </div>
        <div
          class="zhuangtai"
          :class="{ zhuangtaiclick: number === '5' }"
          @click="changeStatus('5')"
        >
          {{$t('stockNeed.tabs4')}}
        </div>
      </div>
      <div>
        <el-form
          :inline="true"
          :model="dataForm"
          @keyup.enter.native="getDataList(1)"
          @submit.native.prevent
          style="margin-top:10px"
          label-width="100px"
        >
          <el-row :gutter="24">
            <!-- <el-col :span="7">
              <el-form-item label="单据编号"
                            label-width="70px">
                <el-input v-model="dataForm.demandCode"
                          placeholder="单据编号"
                          style="width:240px"
                          clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="提交时间"
                            label-width="70px">
                <el-date-picker v-model="valueTime"
                                type="daterange"
                                style="width:240px"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="" label-width="0">
                <el-input
                  v-model="dataForm.searchInput"
                  style="width:250px"
                  :placeholder="$t('stockNeed.placeholder')"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left:0;margin-right:0">
              <el-button
                @click="getDataList(1)"
                type="primary"
                style="width:80px"
                size="medium"
                >{{$t('common.query')}}</el-button
              >
              <el-button
                style="margin-right:10px;"
                class="default-btn"
                @click="reset()"
                size="medium"
                >{{$t('common.reset')}}</el-button
              >
            </el-col>
            <el-col :span="6" style="padding-left:0;margin-right:0">
              <el-button
                type="primary"
                style="float:right;"
                size="medium"
                @click="routerHandle('spareRequirementsAdd')"
                ><i class="el-icon-plus"></i>{{$t('add')}}</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table
        :data="dataList"
        border
        v-loading="loading"
        @selection-change="selectionChangeHandle"
        :key="1"
      >
        <template slot="empty">
          <img src="@/assets/img/good/noGood.png">
          <div>暂无数据</div>
        </template>
        <el-table-column
          type="index"
          width="50"
          header-align="center"
          align="center"
          :label="$t('product.id')"
        ></el-table-column>
        <el-table-column
          prop="demandCode"
          header-align="center"
          align="center"
          :label="$t('product.requisitionNo')"
          width="190"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <a
              href="javascript:"
              @click="openDetailHandle(scope.row.demandId)"
              >{{ scope.row.demandCode }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="oldGoodsNames"
          header-align="center"
          align="left"
          :label="$t('product.productName')"
        >
          <template slot-scope="scope">
            <div :class="['goodsNameColumn', {goodsName: moreClass[scope.$index]}]">
              <template v-for="(item, index) in scope.row.demandDetailVoList">
                <template v-if="index !== 0">，</template>
                <a
                  :key="index"
                  href="javascript:"
                  @click="sparePartsLibraryGoodDetail(item)"
                  v-if="![0].includes(scope.row.status)"
                  >{{ item.oldGoodsName }}</a
                >
                <span v-else :key="index" href="javascript:">{{
                  item.oldGoodsName
                }}</span>
              </template>
            </div>
            <template v-if="hasMoreBtn[scope.$index]">
              <a
                v-show="moreClass[scope.$index]"
                href="javascript:"
                @click="showMore(scope, false)">
                {{$t('common.open')}}
              </a>
              <a
                v-show="!moreClass[scope.$index]"
                href="javascript:"
                @click="showMore(scope, true)">
                {{$t('common.collapse')}}
              </a>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="demandNum"
          header-align="center"
          align="center"
          :label="$t('product.quantity')"
          width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="applyTime"
          header-align="center"
          align="center"
          :label="$t('product.submitTime')"
          width="160"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div>{{ scope.row.applyTime }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="wishEndDate"
          header-align="center"
          align="center"
          width="160"
          :label="$t('product.estimatedTime')"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div>{{ scope.row.wishEndDate | formateDate }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          header-align="center"
          align="center"
          :label="$t('product.status')"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0">{{$t('applystatus.waiting')}}</div>
            <div v-if="scope.row.status === 1">{{$t('applystatus.confirm')}}</div>
            <div v-if="scope.row.status === 4">{{$t('applystatus.cancel')}}</div>
            <div v-if="scope.row.status === 5">{{$t('applystatus.complete')}}</div>
            <div v-if="scope.row.status === 6">{{$t('applystatus.evaluate')}}</div>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          header-align="center"
          align="center"
          width="160"
          :label="$t('handle')"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.status === 0"
              size="small"
              @click="updateHandle(scope.row.demandId)"
              >{{$t('update')}}</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.status === 0"
              size="small"
              @click="deleteHandle(scope.row.demandId)"
              >{{$t('delete')}}</el-button
            >
            <el-button
              type="text"
              size="small"
              v-if="scope.row.status === 1"
              @click="openDetailHandle(scope.row.demandId)"
              >{{$t('product.toConfirm')}}</el-button
            >
            <el-button
              type="text"
              size="small"
              v-if="scope.row.status === 4"
              @click="reApply(scope.row)"
              >{{$t('product.spareAgain')}}</el-button
            >
            <el-button
              type="text"
              size="small"
              v-if="scope.row.status === 5"
              @click="openDetailHandle(scope.row.demandId)"
              >{{$t('product.toEvaluate')}}</el-button
            >
            <el-button
              type="text"
              size="small"
              v-if="[5, 6].includes(scope.row.status)"
              @click="joinShopCart(scope.row)"
              >{{$t('product.addRequisition')}}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import Breadcrumb from '@/components/breadcrumb/index'
import { formateDate } from '@/utils/formateDate'
export default {
  filters: {
    formateDate (val) {
      return formateDate('yyyy-MM-dd', val)
    }
  },
  components: {
    Breadcrumb
  },
  data () {
    return {
      pageTitle: [
        {
          label: this.$t('header.homepage'),
          url: '/'
        },
        {
          label: this.$t('header.storeSpare'),
          url: '/storeSpare'
        },
        {
          label: this.$t('header.spareRequisition')
        }
      ],
      selectList: [],
      dataForm: {
        dateValue: '',
        status: '',
        demandCode: '',
        searchInput: ''
      },
      loading: false,
      shoulinumber: 0,
      querenNumber: 0,
      valueTime: ['', ''],
      number: 'all',
      statusList: [
        { code: '0', value: '待受理' },
        { code: '1', value: '待确认' },
        // { code: 2, value: '备件中' },
        // { code: 4, value: '已取消' },
        { code: '5', value: '已完成' }
        // { code: 6, value: '已评价' }
      ],
      dataList: [],
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      pageSize: 10,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1, // 跳转页
      moreClass: [],
      hasMoreBtn: []
    }
  },
  methods: {
    // 根据领用单 加入购物车
    joinShopCart (row) {
      this.$http
        .post('/front/order/lclb/demand/addShoppingCart', {
          demandId: row.demandId
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )
          this.$message.success(this.$t('product.addRequisitionSuccess'))
        })
    },
    getCurrentDate (format) {
      var now = new Date(format)
      var year = now.getFullYear() // 得到年份
      var month = now.getMonth() // 得到月份
      var date = now.getDate() // 得到日期
      var hour = now.getHours() // 得到小时
      var minu = now.getMinutes() // 得到分钟
      var sec = now.getSeconds() // 得到秒
      month = month + 1
      if (month < 10) month = '0' + month
      if (date < 10) date = '0' + date
      if (hour < 10) hour = '0' + hour
      if (minu < 10) minu = '0' + minu
      if (sec < 10) sec = '0' + sec
      var time = ''
      // 精确到天
      time = year + '-' + month + '-' + date
      return time
    },
    statusListALL () {
      var form = {
        page: this.currentPage,
        limit: this.pageSize,
        status: '',
        demandCode: this.dataForm.demandCode,
        startDate: '',
        endDate: '',
        searchInput: this.dataForm.searchInput,
        companyId:
          localStorage.getItem('defaultCompanyId') !== ''
            ? localStorage.getItem('defaultCompanyId')
            : null
      }
      this.$http
        .post(`/front/order/lclb/demand/getStatusCountByOrdinary`, form)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.shoulinumber = 0
            this.querenNumber = 0
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].status === 0) {
                this.shoulinumber = res.data[i].cnt
              }
              if (res.data[i].status === 1) {
                this.querenNumber = res.data[i].cnt
              }
            }
          }
        })
        .catch(() => {})
    },
    changeStatus (val) {
      this.dataForm.status = val
      this.number = val
      if (val === 'all') {
        this.dataForm.status = ''
      } else {
        this.dataForm.status = val
      }
      this.getDataList()
      // this.statusListALL()
    },
    // 多选
    selectionChangeHandle (list) {
      this.selectList = list
    },
    // 新增
    routerHandle () {
      this.$router.push({ name: 'spareRequirementsAdd' })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.currentPage = val
      this.getDataList()
    },
    getDataList () {
      this.loading = true
      this.statusListALL()
      var form = {
        page: this.currentPage,
        limit: this.pageSize,
        status: this.dataForm.status,
        demandCode: this.dataForm.demandCode,
        startDate: '',
        endDate: '',
        searchInput: this.dataForm.searchInput,
        companyId:
          localStorage.getItem('defaultCompanyId') !== ''
            ? localStorage.getItem('defaultCompanyId')
            : null
      }
      if (this.valueTime) {
        if (this.valueTime[0]) {
          form.startDate = this.getCurrentDate(this.valueTime[0])
        }
        if (this.valueTime[1]) {
          form.endDate = this.getCurrentDate(this.valueTime[1])
        }
      }
      this.moreClass = []
      this.hasMoreBtn = []
      this.$http
        .post(`/front/order/lclb/demand/listByOrdinary`, form)
        .then(({ data: res }) => {
          if (res.data.code === 0) {
            this.dataList = res.data.data
            this.totalPage = res.data.count
            this.$nextTick(() => {
              let goodsNameColumn = document.getElementsByClassName('goodsNameColumn')
              this.dataList.forEach((item, index) => {
                if (goodsNameColumn[index] && goodsNameColumn[index].getBoundingClientRect().height > 46) {
                  this.moreClass.push(true)
                  this.hasMoreBtn.push(true)
                } else {
                  this.moreClass.push(false)
                  this.hasMoreBtn.push(false)
                }
              })
            })
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    showMore (scope, val) {
      this.$set(this.moreClass, scope.$index, val)
    },
    // 清空form
    reset () {
      this.dataForm.searchInput = ''
      // this.dataForm = {
      //   status: '',
      //   demandCode: ''
      // }
      this.valueTime = ['', '']
      this.getDataList(1)
    },
    // 跳转详情
    openDetailHandle (id) {
      this.$router.push({ name: 'spareRequirementsDetail', query: { id: id } })
    },
    // 再次申请备件
    reApply (row) {
      sessionStorage.setItem('reApply', JSON.stringify(row))
      this.$router.push({
        name: 'spareRequirementsAdd',
        query: { reApply: 'true' }
      })
    },
    // 跳转商品详情
    sparePartsLibraryGoodDetail (item) {
      const { spuId = '', skuId = '', custspId = '' } = item
      window.open(
        `/sparePartsLibraryGoodDetail?spuId=${spuId}&skuId=${skuId}&custspId=${custspId}`,
        '_blank'
      )
    },
    updateHandle (id) {
      this.$router.push({ name: 'spareRequirementsUpdate', query: { id: id } })
    },
    deleteHandle (id) {
      this.deleteData(id)
    },
    deleteData (id) {
      this.$confirm(`${this.$t('message.confirmDeleteRequisition')}?`, this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$http
          .post(`/front/order/lclb/demand/deleteByOrdinary`, {
            demandId: id
          })
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.getDataList()
              this.$message.success(this.$t('message.delete'))
            }
          })
          .catch(() => {})
      })
    }
  },
  mounted () {
    this.getDataList()
  },
  beforeRouteEnter (to, from, next) {
    if (!localStorage.getItem('defaultCompanyId')) {
      next({
        name: 'home'
      })
    } else {
      next()
    }
  }
}
</script>
<style>
.lianchulianbei .el-form--inline .el-form-item {
  margin-right: 0 !important;
}
</style>
<style scoped>
.lianchulianbei {
  background: white;
  padding: 20px;
  padding-top: 5px;
}
.conent {
  width: 1190px;
  padding: 20px 20px;
}
.search-row {
  display: flex;
}
.search-conent {
  min-width: 300px;
  margin-right: 20px;
}
.search-but {
  width: 100%;
  min-width: 200px;
  text-align: right;
}
.opt-row {
  width: 100%;
  display: flex;
  text-align: right;
  margin-bottom: 20px;
}
.opt-right {
  width: 300px;
}
.opt-left {
  width: 100%;
  text-align: left;
}
.info-but {
  background: #ffffff;
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #1d65a8;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: 1px solid #1d65a8;
  margin-right: 10px;
}
.info-but:hover {
  background: #1d65a8;
  color: #ffffff;
}
.info-but-new {
  background: #1d65a8;
  color: #ffffff;
}
.but-file {
  background-color: #ffffff;
  border: none;
}
.demand-desc {
  width: 100%;
  cursor: pointer;
}
.tip {
  max-width: 500px;
  word-wrap: break-word;
  word-break: break-word;
}
.red {
  color: red;
}
.detail-icon {
  cursor: pointer;
}
.detail-icon:hover {
  color: #1d65a8;
}
.tooltip-content {
  width: 60px;
  text-align: center;
  border-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.short-content {
  max-height: 69px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tabs {
  height: 48px;
  margin: 0 69px;
}
.tab-item {
  display: inline-block;
  /* padding: 12px 16px; */
  text-align: center;
  background: #ffffff;
  /* box-shadow: inset 0 -1px 0 0 #DDDDDD; */
  /* width: 88px; */
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  letter-spacing: 0;
  margin-right: 24px;
  cursor: pointer;
}
.tab-item-active {
  color: #1d65a8;
  border-bottom: 2px solid #1d65a8;
}
.tab-item-content {
  padding-top: 10px;
}
.zhuangtai {
  width: auto;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: bold;
  color: rgb(56, 50, 50);
  float: left;
  cursor: pointer;
  min-width: 90px;
  padding: 0 15px;
}
.zhuangtaiclick {
  border-bottom: 3px solid #1492ff;
  color: #1492ff;
}
.goodsName {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
